// Market.jsx
// Modern marketplace component with enhanced UX and professional design

import React from 'react';
import ListingFilters from '../../components/ListingFilters';
import { styles } from './styles';
import useMarket from './useMarket';
import MarketHeader from './MarketHeader';
import ListingsGrid from './ListingsGrid';
import EmptyState from './EmptyState';
import LoadingState from './LoadingState';
import './Market.css';

const Market = React.memo(() => {
  const {
    listings,
    loading,
    filters,
    setFilters,
    search,
    setSearch,
    sort,
    setSort
  } = useMarket();

  return (
    <div style={styles.container}>
      {/* Background decoration for modern aesthetic */}
      <div style={styles.backgroundDecoration}></div>
      
      <div style={styles.content} className="market-content">
        {/* Enhanced header with branding */}
        <MarketHeader />
        
        {/* Filters section with modern card design */}
        <div style={styles.filtersSection}>
          <div style={styles.filtersCard} className="filters-card">
            <ListingFilters
              filters={filters}
              setFilters={setFilters}
              search={search}
              setSearch={setSearch}
              sort={sort}
              setSort={setSort}
              showSearch={true}
              showSort={true}
            />
          </div>
        </div>

        {/* Main Content Area with enhanced layout */}
        {loading ? (
          <LoadingState />
        ) : listings.length === 0 ? (
          <EmptyState />
        ) : (
          <div style={styles.listingsSection}>
            <div style={styles.listingsHeader}>
              <h2 style={styles.listingsTitle}>Available Items</h2>
              <p style={styles.listingsCount}>
                {listings.length} {listings.length === 1 ? 'item' : 'items'} found
              </p>
            </div>
            <ListingsGrid listings={listings} />
          </div>
        )}
      </div>
    </div>
  );
});

Market.displayName = 'Market';

export default Market;